import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="external-links"
export default class extends Controller {
  connect() {
    this.processLinks();
  }

  processLinks() {
    const links = this.element.querySelectorAll("a");
    const currentHost = window.location.hostname;

    links.forEach((link) => {
      try {
        const href = link.getAttribute("href");

        // Skip if no href or if it's an anchor/fragment link
        if (!href || href.startsWith("#")) {
          return;
        }

        // Skip if it's a relative link (doesn't start with http:// or https://)
        if (!href.match(/^https?:\/\//)) {
          return;
        }

        // Parse the URL to get the hostname
        const linkUrl = new URL(href);

        // If the hostname is different from current host, it's external
        if (linkUrl.hostname !== currentHost) {
          link.setAttribute("target", "_blank");
          link.setAttribute("rel", "noopener noreferrer");
        }
      } catch (error) {
        // Skip invalid URLs
        console.warn("Could not parse URL:", link.getAttribute("href"), error);
      }
    });
  }
}
